import { createTheme } from 'flowbite-react';

export const theme = createTheme({
    rangeSlider: {
        field: {
            input: {
                base: 'w-full bg-gray-200 rounded-lg appearance-none cursor-pointer [&::-moz-range-thumb]:!bg-primary-700 [&::-webkit-slider-thumb]:!bg-primary-700',
            },
        },
    },
}).rangeSlider;
